/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderFormSchemaFactory, FormRootSchema } from '@gh/builder-shared';
import { FormState, FormStateSchema } from '@gh/common-shared';
import { FormMode, getControl, UploadContext, UploadSlot } from '@gh/core-ui';
import { UserProfilePhoto } from '../../resources';

@Injectable()
export class UserProfilePhotoFormService extends FormState<UserProfilePhoto> {
  pictureSlot: UploadSlot;

  constructor(private uploadContext: UploadContext, schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);

    this.pictureSlot = uploadContext.createUploadSlot({
      entryPoint: 'AVATAR',
    });
  }

  build(signature: UserProfilePhoto): void {
    this.initSchema(signature);

    this.pictureSlot.setControl(getControl(this.group, 'picture'));
  }

  protected buildSchema(_: UserProfilePhoto, { root }: FormStateSchema): FormRootSchema {
    return root({
      mode: FormMode.EditMode,
      enabled: true,
      children: {
        picture: { asyncValidators: [this.pictureSlot.formValidator()] },
      },
    });
  }
}
